module.exports = __webpack_public_path__ + "img/vendict-w-logo.a8ff042.svg";